import { button, row, title } from 'core/style';
import injectSheet, { createStyles } from 'core/style/injectSheet';
import { ITheme, WithStyles } from 'core/style/interfaces';
import { isHtmlEmpty } from 'core/utils';
import React from 'react';
import { ProductFormPublicTypeEnum } from 'site/graphql';
import ProductModal, { IProductModalProduct, IProductModalProductForm } from './ProductModal';

type IProductDescriptionProps = {
    richDescription: string;
    richWarnings: string;
    availableProductForms: IProductModalProductForm[];
    selectedProductFormIndex: number;
    product: IProductModalProduct;
} & WithStyles<typeof styles>;

type IProductDescriptionState = {
    showMoreModal: boolean;
};

class ProductDescription extends React.Component<IProductDescriptionProps, IProductDescriptionState> {
    state: IProductDescriptionState = {
        showMoreModal: false,
    };

    handleOpenMoreModal = () => this.setState({ showMoreModal: true });
    handleCloseMoreModal = () => this.setState({ showMoreModal: false });

    renderShowMoreButton() {
        const { availableProductForms, richWarnings, classes } = this.props;
        // Показываем кнопку "Подробнее", только если есть активный формы с типом вебинар, семинар или заполнено поле "Внимание" у продукта
        const showButton =
            availableProductForms.some(pf =>
                [ProductFormPublicTypeEnum.Webinar, ProductFormPublicTypeEnum.Seminar].includes(pf.type),
            ) || !isHtmlEmpty(richWarnings);

        return (
            showButton && (
                <div className={classes.buttonContainer}>
                    <button className={classes.button} onClick={this.handleOpenMoreModal}>
                        Программа и расписание
                    </button>
                </div>
            )
        );
    }

    render() {
        const {
            classes,
            availableProductForms,
            richDescription,
            selectedProductFormIndex,
            richWarnings,
            product,
        } = this.props;
        const { showMoreModal } = this.state;

        return (
            <>
                <div className={classes.container}>
                    <h2 className={classes.title}>Описание</h2>
                    <div className={classes.description} dangerouslySetInnerHTML={{ __html: richDescription }} />
                    {this.renderShowMoreButton()}
                </div>
                <ProductModal
                    product={product}
                    isOpen={showMoreModal}
                    richWarnings={richWarnings}
                    onClose={this.handleCloseMoreModal}
                    productForms={availableProductForms}
                    selectedProductFormIndex={selectedProductFormIndex}
                />
            </>
        );
    }
}

const styles = (theme: ITheme) =>
    createStyles({
        container: {
            display: 'flex',
            flexDirection: 'column',
        },
        title: {
            ...title({ size: 'h2' }),
            marginBottom: '0.75rem',

            [theme.breakpoints.down('sm')]: {
                textAlign: 'center',
                fontSize: 1.25 + 'rem',
            },
        },
        description: {
            marginBottom: 15,

            '& img': {
                maxWidth: '100%',
            },
        },
        buttonContainer: {
            ...row(),
            marginLeft: 0,
            width: 100 + '%',

            [theme.breakpoints.down('xs')]: {
                justifyContent: 'center',
            },
        },
        button: {
            ...button(theme),
            border: '1px solid #333',
            backgroundColor: 'unset',
            fontWeight: 'bold',
            paddingLeft: 30,
            paddingRight: 30,

            '&:hover, &:focus': {
                color: 'white',
                backgroundColor: '#333',
            },
        },
    });

export default injectSheet(styles, 'ProductDescription')(ProductDescription);
